import Add from "@aus/Assets/Icons/Add";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import Icon from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsAddToListLinkWithIconStyles {
    wrapper?: InjectableCss;
    link?: ProductAddToListLinkStyles;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkWithIconStyles = {
    wrapper: {
        css: css`
            text-align: center;
            align-items: center;
            display: flex;
            justify-content: center;
            margin-top: 15px;
        `,
    },
    link: {
        link: {
            typographyProps: {
                css: css`
                    color: ${getColor("text.main")} !important;
                `,
                size: 18,
            },
        },
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLinkWithIcon: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} className="hideForPrint">
            <Icon src={Add} size={28} style={{ marginRight: "10px" }} />
            <ProductAddToListLink data-test-selector="productDetails_addToList" extendedStyles={styles.link} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAddToListLinkWithIcon)),
    definition: {
        displayName: "Add to List Link With Icon",
        group: "Common",
    },
};

export default widgetModule;
